// extracted by mini-css-extract-plugin
module.exports = {"hidden":"applying_hidden__ari_v","textEmphasis":"applying_textEmphasis__1dje7","wrapper":"applying_wrapper__KmP_v"};